<template lang="pug">
  section.p_concept#concept
    .p_concept-inner
      .p_concept-header._fade.fade_in.scale
        .c_inner
          h2.p_concept-heading.c_heading1
            span.p_concept-heading-text.c_heading1-text Concept
      .p_concept-body
        .p_con(v-for="(item, index) in items", :class="'p_con' + (index + 1)")
          .p_con-col.c_inner.c_col-pc
            .p_con-body
              .p_con-header._fade.fade_in.scale
                h3.p_con-heading
                  span.-text(v-html="item.heading[0]")
              .p_con-text._fade.fade_in.scale
                p(v-for="txt in item.text", v-html="txt")
            .p_con-image._fade.fade_in.scale
                img(:src="getImage('/top', '/img3_' + (index + 1) + '.jpg')")
</template>

<script>
export default {
  name: 'TheConcept',
  data () {
    return {
      items: [
        { heading: [ '「空間が人を育てる」<br>ALHの命を吹き込むオフィス創りへの挑戦' ],
          text: [ '我々、2018年に発足したオフィス構築プロジェクトチームがまず一番初めに確認したことは、「ALHをどのような企業にしていくか」でした。近年、事業が拡大し、社員数が急激に増加するなかで、オフィス機能面での課題が浮き彫りになった状況でしたが、いきなり機能面での課題を整理することではなく、我々は何を始めるにしてもALHのミッション・スタイルからブレイクダウンして計画を立てるようにしています。そこで、ALHのミッションの言葉を切り取るならば、「みんなから愛されるチームになる」、つまり「我々がどのような組織でありたいか」を表現する必要がありました。ALHは人と人の関わりを何よりも大切にし、出会いに感謝することで、愛され成長してく、そのような組織でありたいと、この空間に想いを込めました。', ]
        },
        { heading: [ '心おどるオフィス<br>～だれもがハーモナイズしたくなる空間～', ],
          text: [ '有志で集まったプロジェクトメンバーは様々な部門に属していて、個々の働き方やバックグラウンドが異なるなかで、このオフィスで実現したいコトも異なっていました。モチベーションが上がるオシャレな空間、来訪者をもてなす空間、ミッション・スタイル(企業理念)を浸透させる空間、社員が誇りに思えるようなハイブランドな世界観、社員同士の偶発的なコラボレーションが生まれる空間、集中して作業できるパーソナル空間、機能的で仕事の生産性が高まるスペース、ALHのカルチャーを内外に伝えられる設備など、様々な構想を持ち寄り、ALHの人事ポリシーにもある多様性を尊重する形でメンバー個々に各空間設計を任せ、多様な世界観を表現しました。このVR体験を通して、多くの方々に空間と時間、世界観を共有すべく、その一助となることを願っています。', ]
        },
      ]
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.p_concept {
  @include pc {
    padding: 0 0 vw(160,1400);
  }
  @include sp {
    padding: 0 0 vw(203,750);
  }
  position: relative;

  &::before {
    @include pc {
      height: vw(350,1400);
      background: url("../../../static/img/top/bg3.png") center top no-repeat;
      background-size: cover;
      top: vw(-160,1400);
    }
    @include sp {
      height: vw(311,750);
      background: url("../../../static/img/top/sp/bg3.png") center top no-repeat;
      background-size: cover;
      top: vw(-250,750);
    }
    content: "";
    display: block;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
  }

  &::after {
    @include sp {
      content: "";
      display: block;
      width: 100%;
      height: vw(320,750);
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 0;
      background: url("../../../static/img/top/sp/bg4.png") center top no-repeat;
      background-size: 100% auto;
    }
  }

  &-inner {}

  &-header {
    @include pc {
      text-align: right;
    }
    @include sp {
      margin: 0 0 rem(70,2);
      text-align: center;
    }
    position: relative;
    z-index: 3;
  }

  &-heading {
    &-text {
      @include sp {
        font-size: vw(120,750);
      }
    }
  }

  &-body {
    @include pc {
      margin: rem(-38) 0 0;
    }
  }
}

.p_con {
  position: relative;

  &:not(:first-child) {
    @include sp {
      padding: rem(112,2) 0 0;
    }
  }

  &1  {
    z-index: 2;
  }

  &2 {
    @include pc {
      min-height: vw(620,1400);
      // min-height: rem(620);
      margin: cal(-144,1400) 0 0;
      padding: cal(144,1400) 0 0;
    }
    z-index: 1;
  }

  &-col {}

  &1 &-col {
  }

  &2 &-col {
    @include pc {
      background: url("../../../static/img/top/bg4.png") top center no-repeat;
      background-size: 100% auto;
      flex-direction: row-reverse;
    }
  }

  &-body {
    @include pc {
      width: cal(525,1200);
      position: relative;
    }
  }

  &1 &-body {
    @include pc {
      height: vw(720,1400);
      min-height: rem(720);
    }
  }

  &2 &-body {
    @include pc {
      margin: 0 0 0 auto;
      padding: rem(113) 0 0;
    }
  }

  &-header {
    @include pc {
      margin: 0 0 rem(40);
    }
    @include sp {
      margin: 0 0 rem(25);
    }
  }

  &-heading {
    .-text {
      font-size: rem(24);
      font-weight: bold;
      line-height: (48/24);
    }
  }

  &-text {
    @include pc {
      font-size: rem(16);
    }
    @include sp {
      font-size: rem(14);
    }
    p {
      line-height: (56/28);
    }
  }

  &-image {
    @include pc {
      width: vw(720,1400);
      min-width: rem(525);
      position: absolute;
    }
    @include sp {
      width: calc(100% + 15px);
      margin: rem(112,2) 0 0;
    }
    @include box_shadow();

    img {
      display: block;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  &1 &-image {
    @include pc {
      right: 0;
      top: 0;
      height: 100%;
    }
  }

  &2 &-image {
    @include pc {
      left: 0;
      top: 0;
      height: vw(620,1400);
      min-height: rem(620);
    }
    @include sp {
      margin: rem(112,2) 0 0 rem(-15);
    }
    img {
      object-position: left center;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/top/TheConcept.vue